module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0111.jpg?v=d2f12217";